import { injectToolCSS } from "../utils/cssGenerator";

export const magnifierConfig = {
    id: 'magnifier',
    enable: false,
    css: `
        .asw-magnifier-lens {
            position: fixed;
            width: 250px;
            height: 250px;
            border: 5px solid #444;
            border-radius: 50%;
            cursor: none;
            z-index: 10000001;
            box-shadow: 0 0 30px rgba(0,0,0,0.6), inset 0 0 10px rgba(0,0,0,0.2);
            pointer-events: none;
            display: none;
            overflow: hidden;
            background: white;
            transform: translate3d(0,0,0);
            backface-visibility: hidden;
        }

        .asw-magnifier-lens.active {
            display: block;
        }

        .asw-magnifier-mirror {
            position: absolute;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            transform-origin: 0 0;
            pointer-events: none;
        }

        /* Ensure images and text in mirror are sharp */
        .asw-magnifier-mirror * {
            image-rendering: -webkit-optimize-contrast;
            text-rendering: optimizeLegibility;
        }
    `
};

import isMobile from "../utils/isMobile";

export default function magnifier(enable = false) {
    if (enable && isMobile()) {
        enable = false;
    }

    let lens = document.querySelector('.asw-magnifier-lens') as HTMLElement;
    let mirror: HTMLElement | null = null;
    let mirrorContent: HTMLElement | null = null;

    injectToolCSS({
        ...magnifierConfig,
        enable
    });

    if (enable) {
        if (!lens) {
            lens = document.createElement('div');
            lens.className = 'asw-magnifier-lens';
            
            mirror = document.createElement('div');
            mirror.className = 'asw-magnifier-mirror';
            
            lens.appendChild(mirror);
            document.body.appendChild(lens);
        } else {
            mirror = lens.querySelector('.asw-magnifier-mirror');
        }

        // To create a true mirror, we clone the body's content (excluding the widget)
        const updateMirror = () => {
            if (!mirror) return;
            mirror.innerHTML = '';
            
            // Clone everything except the widget and menu to avoid hall-of-mirrors effect
            const content = document.body.cloneNode(true) as HTMLElement;
            const widgetToRemove = content.querySelector('.asw-widget, .asw-menu, .asw-magnifier-lens');
            if (widgetToRemove) widgetToRemove.remove();
            
            // Remove other transient accessibility elements if they exist
            content.querySelectorAll('.asw-super-focus-highlight, .asw-reading-guide').forEach(el => el.remove());

            mirror.appendChild(content);
            mirrorContent = content;
        };

        const zoom = 2; // Zoom level

        // Initialize content
        updateMirror();

        (window as any).__asw__onMouseMoveMagnifier = (e: MouseEvent) => {
            const x = e.clientX;
            const y = e.clientY;

            // Move the lens
            lens.style.left = `${x - 125}px`;
            lens.style.top = `${y - 125}px`;
            lens.classList.add('active');

            if (mirror) {
                // The math: Move the mirror in the opposite direction, scaled
                // We want the point (x, y) to be at the center of the lens (125, 125)
                // Offset = (center_offset - position * zoom)
                const offsetX = 125 - (x * zoom);
                const offsetY = 125 - (y * zoom);

                mirror.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoom})`;
            }
        };

        (window as any).__asw__onMouseLeaveMagnifier = () => {
            lens.classList.remove('active');
        };

        // Also update mirror on scroll or resize to keep it in sync
        (window as any).__asw__onSyncMagnifier = () => {
             updateMirror();
        };

        document.addEventListener('mousemove', (window as any).__asw__onMouseMoveMagnifier);
        document.addEventListener('mouseleave', (window as any).__asw__onMouseLeaveMagnifier);
        window.addEventListener('scroll', (window as any).__asw__onSyncMagnifier);
        window.addEventListener('resize', (window as any).__asw__onSyncMagnifier);
        
    } else {
        if (lens) {
            lens.remove();
        }

        if ((window as any).__asw__onMouseMoveMagnifier) {
            document.removeEventListener('mousemove', (window as any).__asw__onMouseMoveMagnifier);
            document.removeEventListener('mouseleave', (window as any).__asw__onMouseLeaveMagnifier);
            window.removeEventListener('scroll', (window as any).__asw__onSyncMagnifier);
            window.removeEventListener('resize', (window as any).__asw__onSyncMagnifier);
            
            delete (window as any).__asw__onMouseMoveMagnifier;
            delete (window as any).__asw__onMouseLeaveMagnifier;
            delete (window as any).__asw__onSyncMagnifier;
        }
    }
}
